import { ReduxState } from '~/redux/createRootReducer'

export const withCurrentUser = ({ account: { user: currentUser } }: ReduxState) => ({
  currentUser: currentUser === null ? undefined : currentUser,
})

export const selectIsParcelShop = ({
  account: {
    user: { parcelShopPsfKey },
  },
}: ReduxState) => ({
  isParcelShop: !!parcelShopPsfKey,
})

export const selectParcelShopServices = ({
  account: {
    user: { parcelShopServices },
  },
}: ReduxState) => ({
  parcelShopServices,
})

export const selectIsLoggedIn = ({ account: { isLoggedIn } }: ReduxState) => ({
  isLoggedIn: !!isLoggedIn,
})

export const selectIsInitialUserCheckDone = ({ account: { isInitialUserCheckDone } }: ReduxState) => ({
  isInitialUserCheckDone: !!isInitialUserCheckDone,
})
